module.exports = "<a class=\"button returnButton\" href=\"javascript:;\"></a>\r\n"


/*****************
 ** WEBPACK FOOTER
 ** ./src/shixun-mobile/html/content_module/returnButton.mod
 ** module id = 253
 ** module chunks = 0 24
 **/